var map = {
	"./ar/data.json": [
		96959,
		959
	],
	"./de/data.json": [
		28887,
		887
	],
	"./en/data.json": [
		12719
	],
	"./es/data.json": [
		52750,
		750
	],
	"./fa/data.json": [
		65561,
		561
	],
	"./fi/data.json": [
		24177,
		177
	],
	"./fr/data.json": [
		93494,
		494
	],
	"./he/data.json": [
		33835,
		835
	],
	"./id/data.json": [
		44481,
		481
	],
	"./it/data.json": [
		44177,
		558
	],
	"./ja/data.json": [
		16261,
		261
	],
	"./kk/data.json": [
		52004,
		4
	],
	"./ko/data.json": [
		98464,
		464
	],
	"./ms/data.json": [
		91670,
		670
	],
	"./nl/data.json": [
		3328,
		328
	],
	"./pl/data.json": [
		55454,
		73
	],
	"./pt/data.json": [
		83158,
		158
	],
	"./ru/data.json": [
		51617,
		617
	],
	"./sv/data.json": [
		68885,
		885
	],
	"./tr/data.json": [
		79036,
		36
	],
	"./uk/data.json": [
		46358,
		358
	],
	"./vi/data.json": [
		5793,
		793
	],
	"./zh/data.json": [
		64904,
		904
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 78663;
module.exports = webpackAsyncContext;